//******************新版实名认证相关接口************************
import _axios from "../../index";
import qs from 'qs'

//清除实名
export const clearRealName = data =>
    _axios({
        url: '/identification/clearRealName',
        method: "delete",
        params: data,
    });

//律师所，事业单位企业申请.
export const enterpriseApply = data =>
    _axios({
        url: '/identification/enterprise/apply',
        method: "post",
        data
    });

//新获取营业执照上传地址.
export const businessUploadInfo = data =>
    _axios({
        url: '/identification/enterprise/getUploadInfo',
        method: "get",
        stopLoading: true,
    });

// //新获取营业执照上传地址.
// export const businessUploadInfo = () =>
//     _axios({
//         url: '/identification/enterprise/businessUploadInfo',
//         method: "get",
//         stopLoading:true,
//     });

//获取企业实名认证状态.
export const entStatusInfo = () =>
    _axios({
        url: '/identification/enterprise/entStatusInfo',
        method: "get",
    });

//获取营业执照OCR信息
export const ocrBusinessLicense = data =>
    _axios({
        url: '/identification/enterprise/ocrBusinessLicense',
        method: "get",
        params: data,
        stopLoading: true,
    });

//在线企业认证（新）
export const ordinaryApply = data =>
    _axios({
        url: '/identification/enterprise/ordinaryApply',
        method: "post",
        headers: {
            'content-type': 'application/json;charset=UTF-8',
        },
        returnCatch:true,
        data,
    });

//对公打款企业认证（新）
export const entRemittanceApply = data =>
    _axios({
        url: '/identification/enterprise/entRemittanceApply',
        method: "post",
        headers: {
            'content-type': 'application/json;charset=UTF-8',
        },
        data
    });

//获取授权书下载地址.
export const generateAuthDownloadInfo = () =>
    _axios({
        url: '/identification/enterprise/generateAuthDownloadInfo',
        method: "get",
    });

//获取短信验证码.
export const sendMsg = data =>
    _axios({
        url: '/identification/sendSms',
        method: 'post',
        data: qs.stringify(data),
    });

// 获取对公账户打款页信息
export const remittanceInfo = () =>
    _axios({
        url: '/identification/enterprise/remittanceInfo',
        method: "get",
    });

// 取消企业认证
export const cancel = () =>
    _axios({
        url: '/identification/enterprise/cancel',
        method: "put",
    });

// 获取法人认证授权证书图片
export const authImageInfo = () =>
    _axios({
        url: '/identification/enterprise/authImageInfo',
        method: "get",
    });

//新获取授权证书上传地址.
export const authUploadInfo = data =>
    _axios({
        url: '/identification/enterprise/authUploadInfo',
        params: data,
        method: "get",
    });

//线下申请信息回显.
export const entRemittance = () =>
    _axios({
        url: '/identification/enterprise/entRemittance',
        method: "get",
    });

//生成签名上传地址.
export const generateAutographUploadInfo = () =>
    _axios({
        url: '/identification/enterprise/generateAutographUploadInfo',
        method: "get",
    });

//获取法人实名状态.
export const entLegalStatus = () =>
    _axios({
        url: '/identification/enterprise/entLegalStatus',
        method: "get",
    });

//获取法人实名状态.
export const legalInfoValidated = data =>
    _axios({
        url: '/identification/enterprise/legalInfoValidated',
        method: "get",
        params: data,
    });

//获取法人信息.
export const entLegalInfo = () =>
    _axios({
        url: '/identification/enterprise/entLegalInfo',
        method: "get",
    });


//企业法人认证.签名合成授权书
export const entLegalApply = data =>
    _axios({
        url: '/identification/enterprise/entLegalApply',
        method: "post",
        headers: {
            'content-type': 'application/json;charset=UTF-8',
        },
        data
    });


//获取法人签署授权书成功页信息.
export const legalApplyInfo = () =>
    _axios({
        url: '/identification/enterprise/legalApplyInfo',
        method: "get",
    });

//pc人脸.
export const faceApply = () =>
    _axios({
        url: '/identification/personal/face/h5/apply',
        method: "get",
    });


//H5人脸.
export const aloneApply = data =>
    _axios({
        url: '/identification/face/alone/apply',
        method: "get",
        params: data,
    });

//H5人脸成功回调
export const aloneCallback = data =>
    _axios({
        url: '/identification/face/alone/callback',
        method: "get",
        params: data,
    });

//更新企业认证
export const updateEntInfo = data =>
    _axios({
        url: '/identification/enterprise/updateEntInfo',
        method: "put",
        params: data,
    });

//企业法人手机三要素认证
export const phoneAuthApprove = data =>
    _axios({
        url: '/identification/personal/phoneAuthApprove',
        method: "post",
        data: qs.stringify(data),
    });

//企业法人银行卡三要素认证
export const bankAuthApprove = data =>
    _axios({
        url: '/identification/personal/bankAuthApprove',
        method: "post",
        data: qs.stringify(data),
    });

//实名协议签署 'DC'数字证书
export const identificationProtocol = (data) => {
    if (!data) {
        data = {
            protocolType: 'KYC'//默认实名认证协议，兼容之前没有传参数给个默认参数
        };
    }
    return _axios({
        url: '/sign/signProtocol',
        method: "post",
        data: qs.stringify(data)
    });
}

// 获取身份证上传地址
export const getIdCardUploadUrl = () =>
    _axios({
        url: '/identification/enterprise/generateIdCardUploadInfo',
        method: "get",
        stopLoading: true,
    });

//企业对公打款认证补充信息实名
export const entRemittanceSupply = (data) =>
    _axios({
        url: '/identification/enterprise/entRemittanceSupply',
        method: "post",
        headers: {
            'content-type': 'application/json;charset=UTF-8',
        },
        data,
    });

//企业对公打款认证重新认证数据回显    
export const entRemittanceFeedback = () =>
    _axios({
        url: '/identification/entRemittanceFeedback',
        method: "get",
        stopLoading: true,
    });